export const QueryKey = {
  Resource: {
    Organization: 'organization',
    OrganizationUsers: 'organization-users',
    OrganizationTasks: 'organization-tasks',
    OrganizationMembers: 'organization-members',
    OrganizationSummary: 'organization-summary',
    OrganizationSummaryActionItems: 'organization-summary-action-items',
    OrganizationEmployees: 'organization-employees',
    OrganizationTeamMembers: 'organization-team-members',
    OrganizationCoworkers: 'organization-coworkers',
    OrganizationComments: 'organization-comments',
    ChildOrganizations: 'child-organizations',
    OrganizationAudits: 'organization-audits',
    OrganizationSibContractAudits: 'organization-sib-contract-audits',
    OrganizationSibContracts: 'organization-sib-contracts',
    OrganizationSibServices: 'organization-sib-services',
    OrganizationSibInvoiceOccurrences: 'invoice-occurrences',
    OrganizationSibChargeValues: 'charge-values',
    OrganizationSibDeactivationPreview: 'deactivation-preview',
    AuditNegotiations: 'audit-negotiations',
    AuditNegotiationsClientMeetings: 'audit-negotiations-client-meetings',
    AuditDocuments: 'audit-documents',
    AuditVendorAccounts: 'audit-vendor-accounts',
    AuditComments: 'audit-comments',
    AuditSpendEstimated: 'audit-spend-estimated',
    AuditSpendEstimatedVendorAccounts: 'audit-spend-estimated-vendor-accounts',
    AuditPercentageBasisCandidates: 'audit-percentage-basis-candidates',
    AuditPercentageBasisTotal: 'audit-percentage-basis-total',
    AuditInitialValidationInvoices: 'audit-initial-validation-invoices',
    AuditInitialValidationInvoiceLocations:
      'audit-initial-validation-invoice-locations',
    AuditInitialValidationSpends: 'audit-initial-validation-spends',
    AuditInitialValidationAttachableInvoices:
      'audit-initial-validation-attachable-invoices',
    AuditInitialValidationSpendGroups: 'audit-initial-validation-spend-groups',
    AuditInitialValidationValidationSpendGroupNotes:
      'audit-initial-validation-validation-spend-group-notes',
    AuditBackfill: 'audit-backfill',
    AuditMonitoringSavingsSpends: 'audit-monitoring-savings-spends',
    SpendRounds: 'spend-rounds',
    OptimizationSubjects: 'optimization-subjects',
    InvoiceTemplates: 'invoice-templates',
    DataEntryInvoices: 'data-entry-invoices',
    ValidationSpendGroupPeriods: 'validation-spend-group-periods',
    ValidationSpendGroupPeriodNotes: 'validation-spend-group-period-notes',
    AuditSpendNotes: 'audit-spend-notes',
    SpendValues: 'spend-values',
    VendorAccounts: 'vendor-accounts',
    OrganizationLocations: 'organization-locations',
    OrganizationLocationsSelectList: 'organization-locations-select-list',
    OrganizationAllowedDomains: 'organization-allowed-domains',
    OrganizationAdditionalColumns: 'organization-additional-columns',
    OrganizationOverview: 'organization-overview',
    SubAudits: 'sub-audits',
    SubAuditsComments: 'sub-audits-comments',
    SubAuditHistory: 'sub-audit-history',
    User: 'user',
    UserOrganizations: 'user-organizations',
    UserPreferences: 'user-preferences',
    UserSettings: 'user-settings',
    InvitedUsers: 'invited-users',
    Task: 'task',
    TaskComments: 'task-comments',
    SiteList: 'site-list',
    VectorSiteList: 'vector-site-list',
    SiteListFiles: 'site-list-files',
    Subtask: 'subtask',
    RecurringTask: 'recurring-task',
    ActionItem: 'action-item',
    SpendArea: 'spend-area',
    SavingsSummary: 'savings-summary',
    SpendAreaSavings: 'spend-area-savings',
    AnnualSpendAreaSavings: 'annual-spend-area-savings',
    SpendCategories: 'spend-categories',
    Documents: 'documents',
    DocumentColumnMaxValues: 'document-column-max-values',
    DocumentTypeSelectList: 'document-type-select-list',
    DocumentVendorSelectList: 'document-vendor-select-list',
    DocumentCategoryManagerSelectList: 'document-category-manager-select-list',
    Notifications: 'notifications',
    ExternalUsers: 'external-users',
    Teams: 'teams',
    TeamsSingle: 'teams-single',
    TeamMembers: 'team-members',
    DocumentTags: 'document-tags',
    Tags: 'tags',
    ClientContacts: 'client-contacts',
    VendorContacts: 'vendor-contacts',
    TaskHistory: 'task-history',
    AssignedTasks: 'assigned-tasks',
    Vendors: 'vendors',
    VendorsServiceCategories: 'service-categories',
    VendorsSelectList: 'vendors-select-list',
    PowerBiOrganizationReports: 'power-bi-organization-reports',
    Template: 'template',
    TaskCount: 'task-count',
    Changelogs: 'changelogs',
    Members: 'members',
    Tickets: 'tickets',
    Invoices: 'invoices',
    OrganizationActiveTasks: 'organization-active-tasks',
    OrganizationTickets: 'organization-tickets',
    TicketTypeGroup: 'ticket-type-group',
    TicketStatusGroup: 'ticket-status-group',
    TicketOrganizationGroup: 'ticket-organization-group',
    TicketAssigneeGroup: 'ticket-assignee-group',
    TicketComments: 'ticket-comments',
    TicketFiles: 'ticket-files',
    TicketHistory: 'ticket-history',
    TicketRelatedTasks: 'ticket-related-tasks',
    Faqs: 'faqs',
    VectorContracts: 'vector-contracts',
    VirtualDocuments: 'virtual-documents',
    Projects: 'projects',
    ProjectTickets: 'project-tickets',
    VendorTickets: 'vendor-tickets',
    VendorContracts: 'vendor-contracts',
    ProjectFiles: 'project-files',
    InternalPortalOrganizations: 'internal-portal-organizations',
    InternalPortalLocations: 'internal-portal-locations',
    InternalPortalActionItems: 'internal-portal-action-items',
    InternalPortalGlobalWorkActionItems:
      'internal-portal-global-work-action-items',
    InternalPortalDashboardMetrics: 'internal-portal-dashboard-metrics',
    InternalPortalDashboardManagedOrganizations:
      'internal-portal-dashboard-managed-organizations',
    InternalPortalDashboardPinnedOrganizations:
      'internal-portal-dashboard-pinned-organizations',
    InternalPortalDashboardPinnedVendors:
      'internal-portal-dashboard-pinned-vendors',
    InternalPortalDashboardPinnedProjects:
      'internal-portal-dashboard-pinned-projects',
    InternalPortalDashboardPinnedTeams:
      'internal-portal-dashboard-pinned-teams',
    InternalPortalDashboardPinnedAudits:
      'internal-portal-dashboard-pinned-audits',
    InternalPortalVendors: 'internal-portal-vendors',
    InternalPortalContacts: 'internal-portal-contacts',
    SidecarDocumentBulkEditVendor: 'sidecar-document-bulk-edit-vendor',
    BlobHealthCheck: 'blob-health-check',
    OrganizationMainPointOfContact: 'organization-main-point-of-contact',
    InternalPortalVendorSpendCategories:
      'internal-portal-vendor-spend-categories',
    InternalPortalVendorSpendAreasSelectList:
      'internal-portal-vendor-spend-areas-select-list',
    InternalPortalVendorSpendCategoriesSelectList:
      'internal-portal-vendor-spend-categories-select-list',
    OrganizationAuditSpendCategoriesSelectList:
      'organization-audit-spend-categories-select-list',
    OrganizationAuditVendorsSelectList:
      'organization-audit-vendors-select-list',
    InternalPortalVendorOrganizations: 'internal-portal-vendor-organizations',
    InternalPortalVendorAccounts: 'internal-portal-vendor-accounts',
    InternalPortalVendorAccountsSelectList:
      'internal-portal-vendor-accounts-select-list',
    InternalPortalOnlineAccess: 'internal-portal-online-access',
    InternalPortalOnlineAccessSecrets: 'internal-portal-online-access-secrets',
    InternalPortalOrganizationContacts: 'internal-portal-organization-contacts',
    InternalPortalSibEmployees: 'internal-portal-sib-employees',
    VendorsImportTemplate: 'vendors-import-template',
    TosContent: 'tos-content',
    InternalPortalUnassignedToOrganizationVendors:
      'internal-portal-unassigned-to-organization-vendors',
    InternalPortalVendorUnlinkSummary: 'internal-portal-vendor-unlink-summary',
    Banks: 'banks',
    GlobalSearch: 'global-search',
    VsrReports: 'vsr-reports',
  },
  Operation: {
    List: 'list',
    One: 'one',
    Infinite: 'infinite',
    Count: 'count',
    Authors: 'authors',
    AverageDuration: 'average-duration',
    Status: 'status',
    Spends: 'spends',
  },
};

export { HttpStatusCode } from 'axios';

export enum MutationKey {}

export enum StoragePrefix {
  Document = 'document',
  OrganizationLogo = 'organization-logo',
  ProfilePicture = 'profile-picture',
  Zip = 'zip',
}

export enum BillingContactProvider {
  Vector = 'Vector',
  Sib = 'Sib',
}
